
import { Component, Prop, Vue } from 'vue-property-decorator';

import GoogleMaps from '../../anonymous/GoogleMaps.vue';

import TextField from '../../../../framework/fields/TextField.vue';
import SelectField from '../../../../framework/fields/SelectField.vue';
import SwitchField from '../../../../framework/fields/SwitchField.vue';

import { sharedState } from '../../../../framework/state';
import { getResource } from '../../../../framework/client/resource';
import { getEnumerationOptions, getOptionLabel } from '../../../../framework/service/options';

import { VendorType } from '../../../../../common/application/model/enums/VendorType';
import { VendorLocation } from '../../../../../common/application/model/VendorLocation';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { getVendorOptions } from '../../../service/application_options_service';

@Component({
    components: {
        SelectField,
        TextField,
        SwitchField,
        GoogleMaps,
    },
})
export default class ViewVendorLocation extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VENDOR_LOCATION;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        row: {} as VendorLocation,
        vendorTypeOptions: [] as { id: string | undefined; label: string }[],
        vendorOptions: [] as { id: string | undefined; label: string }[],
        vendorType: '',
        loading: false,
        parentVendor: undefined as string | undefined,
    };

    // Functions
    async mounted() {
        this.local.loading = true;
        this.local.vendorTypeOptions = getEnumerationOptions('VendorType', Object.keys(VendorType), this);
        this.local.row = (await getResource<VendorLocation>(this.resourceType, this.id))!!;
        this.local.vendorOptions = await getVendorOptions();
        this.local.vendorType = getOptionLabel(this.local.row.vendorType, this.local.vendorTypeOptions);
        this.local.parentVendor = getOptionLabel(this.local.row.parentId, this.local.vendorOptions);
        this.local.loading = true;
    }

    back() {
        this.$router.go(-1);
    }

    edit() {
        this.$router.push(`/vendor-location/${this.local.row.id}/edit`);
    }

    get coords(): google.maps.LatLngLiteral {
        return {
            lat: this.local.row.lat,
            lng: this.local.row.lng,
        };
    }

    get fullAddress(): string {
        if (!this.local.row.street) {
            return '';
        }

        return `${this.local.row.street}, ${this.local.row.zip} ${this.local.row.city}`;
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }
}
